import { ChatAgentMessage } from "@components/ChatAgent";
import { Avatar, Slide, useTheme } from "@mui/material";
import React from "react";
import { UserDadaType } from "@context/auth/types";
import AnimatedChatLoadingComponent from "@components/ChatAgent/components/AnimatedChatLoading/AnimatedChatLoading.component";
import {
  AvatarContainer,
  Container,
  MessageBox,
  MessageContainer,
} from "@components/ChatAgent/components/ChatAgentMessageBox/style";
import ReactMarkdown from "react-markdown";

interface ChatAgentMessageBoxProps {
  index: number;
  message: ChatAgentMessage;
  user?: UserDadaType;
}

const ChatAgentMessageBox = ({
  index,
  message,
  user,
}: ChatAgentMessageBoxProps) => {
  const theme = useTheme();
  const isAI = message.sender === "assistant";

  const MessageAvatar = () => {
    return (
      <Avatar alt={"Message Avatar"} sx={{ width: "37px", height: "37px" }}>
        {isAI
          ? "AI"
          : user
            ? `${user.name.charAt(0)}${user.surname.charAt(0)}`
            : ""}
      </Avatar>
    );
  };

  return (
    <Slide direction={"up"} in mountOnEnter unmountOnExit>
      <Container isAI={isAI} messageIndex={index} gap={"10px"}>
        <AvatarContainer theme={theme} isAI={isAI}>
          <MessageAvatar />
        </AvatarContainer>
        <MessageContainer theme={theme} isAI={isAI}>
          {message.response === "" ? (
            <AnimatedChatLoadingComponent />
          ) : (
            <MessageBox>
              <ReactMarkdown>{message.response}</ReactMarkdown>
            </MessageBox>
          )}
        </MessageContainer>
      </Container>
    </Slide>
  );
};

export default ChatAgentMessageBox;
